











































































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { IContract, ContractStateEnum, ContractPhaseEnum } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';
import ContractStateActions from './ContractStateActions.vue';

export default mixins(auth).extend({
  name: 'ContractDetailOptionsButton',

  components: {
    ConfirmationDialog,
    DetailOptionsButton,
    ContractStateActions
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      deleteContractDialog: false,
      contractDeleteInProgress: false,
      error: null as null | ISystemError,
      ContractStateEnum,
      ContractPhaseEnum
    };
  },

  methods: {
    ...mapActions({
      deleteContract: 'contract/deleteContract'
    }),

    cancelContractDeleteDialog() {
      this.deleteContractDialog = false;
    },

    removeContract() {
      this.clearErrors();
      this.contractDeleteInProgress = true;
      this.deleteContract(this.contract.id)
        .then(() => {
          this.deleteContractDialog = false;
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.contractDeleteInProgress = false;
        });
    },

    clearErrors() {
      this.error = null;
    }
  }
});
